import { __awaiter, __rest } from '../../../../../_virtual/_tslib.js';
import { usePromise } from '../usePromise/usePromise.js';
import '@dynamic-labs/sdk-api';
import { logger } from '../../../shared/logger.js';
import '../../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/utils';
import '../../constants/colors.js';
import 'ethers';
import '../../../shared/consts/index.js';

const useTransactionEstimatedGas = (provider, transaction) => usePromise(() => __awaiter(void 0, void 0, void 0, function* () {
    // To safely run estimateGas using alchemy, we need to remove the from address
    // because alchemy checks the origin address funds and can return an error if
    // origin wallet has no funds for the transaction
    // https://docs.alchemy.com/reference/eth-estimategas
    const { from } = transaction, transactionWithNoOrigin = __rest(transaction, ["from"]);
    try {
        return yield provider.estimateGas(transactionWithNoOrigin);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (err) {
        logger.error(err);
        // If the error is UNPREDICTABLE_GAS_LIMIT, we try to estimate gas again
        // with original transaction
        // https://docs.ethers.org/v5/troubleshooting/errors/#help-UNPREDICTABLE_GAS_LIMIT
        if (err.code === 'UNPREDICTABLE_GAS_LIMIT') {
            return provider.estimateGas(transaction);
        }
        throw err;
    }
}));

export { useTransactionEstimatedGas };
